export default __webpack_public_path__ + "static/media/logo_ba_font_01.472db609.png";